/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { getDataManagerUrl } from '@jira/servicedesk__insight-common-utils-insight-urls/src/getLandingPageUrl.tsx';
import ArrowUpRightIcon from '@atlaskit/icon/core/arrow-up-right';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import JSMAssetsDataManagerIcon from '@jira/illustrations__icons/src/ui/jsm-assets-data-manager/index.tsx';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { ASSETS_DATA_MANAGER } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import { useFormattedMessageAndIcon } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import { useAssetsUIAnalytics } from '../../use-assets-ui-analytics/index.tsx';

const assetsDataManager = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Data Manager',
	description: 'Name of a link to "Data Manager" which is product name that should be capitalised',
});

const assetsOpenDataManager = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-open-data-manager',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Open Data Manager',
	description: 'Icon label to open "Data Manager" which is product name that should be capitalised',
});

const assetsDataManagerBeta = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager.assets-data-manager-beta',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Beta',
	description: 'Indicates that the product is in "beta" (early access)',
});

export const DataManagerMenuItems = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { icon: formattedOpenIcon } = useFormattedMessageAndIcon(
		assetsOpenDataManager,
		ArrowUpRightIcon,
	);
	const { icon: formattedDataManagerIcon } = useFormattedMessageAndIcon(
		assetsDataManager,
		JSMAssetsDataManagerIcon,
	);

	const { fireUINavigationItemAnalytics } = useAssetsUIAnalytics();

	return (
		<LinkMenuItem
			elemBefore={formattedDataManagerIcon}
			elemAfter={formattedOpenIcon}
			href={getDataManagerUrl()}
			target="_blank"
			onClick={() => fireUINavigationItemAnalytics(ASSETS_DATA_MANAGER)}
		>
			<Inline space="space.050" alignBlock="baseline">
				{formatMessage(assetsDataManager)}
				<Lozenge appearance="new">{formatMessage(assetsDataManagerBeta)}</Lozenge>
			</Inline>
		</LinkMenuItem>
	);
};
